<style scoped lang="scss">
.alert-info {
  padding: 0.9rem 0.9rem 0.75rem 1.25rem;
  margin-bottom: 1rem;
  width: 100%;
}
</style>
<template>
  <section>
    <div class="card">
      <div class="card-header">
        <h4>Backup einstellungen</h4>
      </div>
      <div class="card-body">
        <div class="form-group row">
          <col-label>sftp_host</col-label>
          <div class="col-8">
            <input type="email" class="form-control" v-model="data.sftp_host" />
          </div>
        </div>
        <div class="form-group row">
          <col-label>sftp_username</col-label>
          <div class="col-8">
            <input class="form-control" v-model="data.sftp_username" />
          </div>
        </div>
        <div class="form-group row">
          <col-label>sftp_password</col-label>
          <div class="col-8">
            <input class="form-control" v-model="data.sftp_password" />
          </div>
        </div>
        <div class="form-group row">
          <col-label>sftp_port</col-label>
          <div class="col-8">
            <input class="form-control" v-model="data.sftp_port" />
          </div>
        </div>
        <hr />
        <div class="form-group row">
          <col-label>backupMailAdress</col-label>
          <div class="col-8">
            <input
              type="email"
              class="form-control"
              v-model="data.backupMailAdress"
            />
          </div>
        </div>
        <div class="form-group row">
          <col-label>backupTimeDB</col-label>
          <div class="col-8">
            <input class="form-control" v-model="data.backupTimeDB" />
          </div>
        </div>
        <div class="form-group row">
          <col-label>backupTimeFiles</col-label>
          <div class="col-8">
            <input class="form-control" v-model="data.backupTimeFiles" />
          </div>
        </div>
        <div class="form-group row">
          <col-label>Backup aktiv</col-label>
          <div class="col-8">
            <div class="custom-control custom-checkbox">
              <input
                class="form-check-input custom-control-input"
                type="checkbox"
                v-model="data.backupFiles"
                id="backupFiles"
              />
              <label
                class="form-check-label custom-control-label"
                for="backupFiles"
                >Files</label
              >
            </div>
            <div class="custom-control custom-checkbox">
              <input
                class="form-check-input custom-control-input"
                type="checkbox"
                v-model="data.backupDB"
                id="backupDB"
              />
              <label
                class="form-check-label custom-control-label"
                for="backupDB"
                >Database</label
              >
            </div>
          </div>
        </div>
        <div class="form-group">
          <button @click="persist()" class="btn btn-primary">Speichern</button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <h4>Manuelles Backup</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div v-if="backupRunning()" class="alert-info" role="alert">
            Ein Backup für <i>{{ backupRunning() }}</i> läuft im Moment.
          </div>
          <div class="col-12">
            <div class="form-group">
              <button
                :disabled="backupRunning() != ''"
                @click="backup('files')"
                class="btn btn-default"
              >
                Files
              </button>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <button
                :disabled="backupRunning() != ''"
                @click="backup('database')"
                class="btn btn-default"
              >
                Database
              </button>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <button
                :disabled="backupRunning() != ''"
                @click="backup('files+database')"
                class="btn btn-default"
              >
                Full Backup
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="babel">
export default {
  created() {
    this.$store.dispatch("manualBackup/read");
    this.$store.dispatch("setting/all").then(() => {
      const settings = this.$store.getters["setting/all"];
      Object.keys(settings).forEach(key => {
        this.data[key] = settings[key];
      });
    });
  },
  methods: {
    backupRunning() {
      return this.$store.getters["manualBackup/manualBackup"];
    },
    backup(type) {
      this.$http
        .post("/api/v1/manualBackup", {type: type})
        .then(() => {
          this.$store.commit("manualBackup/update", type);
          this.$notify({
            title: `Das Backup wird gestartet`,
            type: "success"
          });
        });
    },
    persist() {
      const data = Object.assign({}, this.data);
      this.$store.dispatch("setting/update", data).then(() => {
        this.$notify({
          title: "Einstellungen gespeichert",
          type: "success"
        });
      });
    }
  },
  data() {
    return {
      data: {
        backupMailAdress: '',
        backupTimeDB: '* * * * *',
        backupTimeFiles: '* * * * *',
        sftp_host: '',
        sftp_username: '',
        sftp_password: '',
        sftp_port: ''
      }
    };
  }
};
</script>
